import { gql } from '@apollo/client';

const CAN_I_ACCESS_BID = gql`
  query Query($bidId: String!) {
    canIAccessThisBid(bidId: $bidId)
  }
`;

export default CAN_I_ACCESS_BID;
